module.exports = __webpack_public_path__ + "static/media/saba-island.5722c45b.svg";